import type { ReactNode } from 'react';
import { Center, Paper, Stack, Text, Title } from '@mantine/core';
import { Wordmark } from '@/layout/AppLayout';

export function AuthCard({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Center mih="100vh" p="md">
      <Paper withBorder p="xl" radius="md" w="100%" maw={420} className="pb-surface" shadow="sm">
        <Stack gap="lg">
          <Wordmark />
          <div>
            <Title order={1} size="h2">
              {title}
            </Title>
            {subtitle && (
              <Text size="sm" c="dimmed" mt={4}>
                {subtitle}
              </Text>
            )}
          </div>
          {children}
        </Stack>
      </Paper>
    </Center>
  );
}
